import type { Priority } from '@/types'

export interface SLAConfig {
  priority: Priority
  responseTimeHours: number
  resolutionTimeHours: number
}

export const DEFAULT_SLA_CONFIG: Record<Priority, SLAConfig> = {
  critical: {
    priority: 'critical',
    responseTimeHours: 1,
    resolutionTimeHours: 4,
  },
  high: {
    priority: 'high',
    responseTimeHours: 4,
    resolutionTimeHours: 24,
  },
  medium: {
    priority: 'medium',
    responseTimeHours: 8,
    resolutionTimeHours: 48,
  },
  low: {
    priority: 'low',
    responseTimeHours: 24,
    resolutionTimeHours: 72,
  },
}

export function calculateSLADueDate(
  createdAt: Date,
  priority: Priority,
  type: 'response' | 'resolution'
): Date {
  const config = DEFAULT_SLA_CONFIG[priority]
  const hours = type === 'response' ? config.responseTimeHours : config.resolutionTimeHours
  const dueDate = new Date(createdAt)
  dueDate.setHours(dueDate.getHours() + hours)
  return dueDate
}

export function getSLAStatus(
  dueDate: Date,
  completedAt?: Date
): 'on_time' | 'at_risk' | 'overdue' {
  const now = completedAt || new Date()
  const timeDiff = dueDate.getTime() - now.getTime()
  const hoursRemaining = timeDiff / (1000 * 60 * 60)

  if (timeDiff < 0) {
    return 'overdue'
  } else if (hoursRemaining <= 2) {
    return 'at_risk'
  }
  return 'on_time'
}
